import * as Yup from 'yup';

export const createShippingModalityValidationSchema = (
  modalityCodes: string[],
) => {
  const modalitySchemas = modalityCodes.reduce((acc, code) => {
    acc[code] = Yup.object().shape({
      additionalDays: Yup.string().test(
        'additionalDaysRange',
        'shippingModalities.errors.additionalDaysLimit',
        (value) => {
          if (value && (Number(value) < 0 || Number(value) > 365)) {
            return false;
          }
          return true;
        },
      ),
      id: Yup.string(),
      code: Yup.string(),
      optionName: Yup.string(),
      isEnabled: Yup.boolean(),
      allowedFreeShipping: Yup.boolean(),
    });
    return acc;
  }, {} as Record<string, any>);

  return Yup.object().shape(modalitySchemas);
};
